import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Level } from "@modules/levels/types";
import { LevelFormValues } from "@modules/levels/validations";

import { createLevelService } from "./service";
import { UseCreateLevelMutationOptions } from "./types";

export function useCreateLevelMutation(
  options?: UseCreateLevelMutationOptions
) {
  const { open } = useNotification();

  return useMutation<Level, ApiError, LevelFormValues>({
    mutationFn: createLevelService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
